<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss">
  @import '../node_modules/@ericpitcock/ep-design-system/src/assets/scss/_reset.scss';

  @font-face {
    font-family: 'GT America Condensed Regular';
    src: url('../node_modules/@ericpitcock/ep-design-system/src/assets/fonts/GT-America-Condensed-Regular.woff2') format('woff2');
  }
  @font-face {
    font-family: 'GT America Condensed Regular Italic';
    src: url('../node_modules/@ericpitcock/ep-design-system/src/assets/fonts/GT-America-Condensed-Regular-Italic.woff2') format('woff2');
  }
  @font-face {
    font-family: 'GT America Condensed Medium';
    src: url('../node_modules/@ericpitcock/ep-design-system/src/assets/fonts/GT-America-Condensed-Medium.woff2') format('woff2');
  }
  @font-face {
    font-family: 'GT America Condensed Medium Italic';
    src: url('../node_modules/@ericpitcock/ep-design-system/src/assets/fonts/GT-America-Condensed-Medium-Italic.woff2') format('woff2');
  }

  body {
    font-family: 'GT America Condensed Regular';
    font-size: 14px;
    background: $white;
  }

  #app {
    height: 100vh;
  }
</style>
